
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.669 0C18.07 0 19.99 1.929 20 5.33v9.34c0 3.4-1.93 5.33-5.331 5.33H5.33C1.929 20 0 18.07 0 14.67V5.33C0 1.929 1.929 0 5.33 0h9.339zM10.5 4.13a.84.84 0 00-1.281.79v10.19c.051.43.41.75.83.75.431 0 .79-.32.83-.75V4.92a.815.815 0 00-.379-.79zM5.83 7.41a.823.823 0 00-.88 0 .84.84 0 00-.39.79v6.91c.039.43.399.75.829.75.431 0 .79-.32.83-.75V8.2a.842.842 0 00-.389-.79zm9.259 3.63a.839.839 0 00-.889 0 .806.806 0 00-.38.79v3.28c.04.43.399.75.83.75.42 0 .779-.32.83-.75v-3.28a.834.834 0 00-.391-.79z"}})])
          )
        }
      }
    